import { CancelPresentation } from '@material-ui/icons';
import React, { FC } from 'react';

import { useHeader } from '../../components/common/navigation/hooks/header-service';

const Error404: FC = () => {
  useHeader('Страница не найдена (404)');

  return (
    <>
      <div
        style={{
          fontSize: 'x-large',
          textAlign: 'center',
          paddingTop: '230px',
          color: 'light-gray',
        }}
      >
        <CancelPresentation fontSize="large" color="disabled" />
        <div>Пусто</div>
      </div>
    </>
  );
};

export default Error404;
